// @flow
import Loadable from 'react-loadable'

import Loader from '@src/components/ui/ReactLoadableLoader'

const AddBalanceLoader = Loadable({
  loader: () => import('./AddBalanceContainer'),
  loading: Loader,
})

export default AddBalanceLoader
